export const API_GRANTED_ORGANISATIONS_INDEX = 'API_GRANTED_ORGANISATIONS_INDEX'

export const fetchGrantedOrganisations = (query: string) => ({
  type: API_GRANTED_ORGANISATIONS_INDEX,
  query,
})
